import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import gsap from 'gsap';
import objectFitVideos from 'object-fit-videos';
import objectFitImages from 'object-fit-images';
import videojs from 'video.js';
import barba from '@barba/core';
import barbaRouter from '@barba/router';
import AOS from 'aos';

svg4everybody();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;
window.barba = barba;
window.videoJs = videojs;
window.barbaRouter = barbaRouter;
window.objectFitImages = objectFitImages;
window.objectFitVideos = objectFitVideos;
window.AOS = AOS;

require('@fancyapps/fancybox/dist/jquery.fancybox.min');
require('ninelines-ua-parser');

$('[data-fancybox]').fancybox({
	toolbar: false,
	smallBtn: true,
	iframe: {
		preload: false,
	},
});
